import { Context } from "../Engine";
import { VertexBuffer } from "../Object/VertexBuffer";
import { vec3 } from "gl-matrix";
import { IDrawableObject, ObjectInteraction } from "../Object/ObjectManager";
import { PropertyAnimation } from "@spi/Common/Animation/PropertyAnimation";

export class LineList implements IDrawableObject {

    animatedProperties: PropertyAnimation;
    interaction: ObjectInteraction;

    public ctx: Context;

    private buffer: VertexBuffer;

    constructor(ctx: Context) {
        this.ctx = ctx;
        this.buffer = new VertexBuffer(ctx.gl.createBuffer(), ctx.gl.LINES, 0, 0);
        this.setLines([]);
    }

    public setLines(coordList: (vec3 | number[])[]) {
        this.setMultiLines([coordList]);
    }

    public setMultiLines(coordLists: (vec3 | number[])[][]) {
        let gl = this.ctx.gl;
        let geometry: number[] = [];

        for (let coordList of coordLists) {

            let previousCoord = coordList.length > 0 ? coordList[0] : vec3.create();
            for (let coords of coordList) {
                geometry.push(previousCoord[0], previousCoord[1], previousCoord[2]);
                geometry.push(coords[0], coords[1], coords[2]);

                previousCoord = coords;
            }
        }
        gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer.glVertexBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(geometry), gl.DYNAMIC_DRAW);

        this.buffer.itemSize = 3;
        this.buffer.itemCount = geometry.length / 3;
    }

    public getModes() {
        return ['main'];
    }

    public getShaderReference(mode: string) {
        return 'debug.lines';
    }

    public draw(ctx: Context, picking: boolean): void {
        let vertexBuffer = this.buffer;

        if (vertexBuffer.itemCount == 0) {
            return;
        }

        let gl = ctx.gl;

        let shader = ctx.setShader('debug.lines');

        let floatSize = Float32Array.BYTES_PER_ELEMENT;

        gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer.glVertexBuffer);
        gl.vertexAttribPointer(shader.attributes.vertexPosition, 3, gl.FLOAT, false, floatSize * 3, 0);

        gl.uniformMatrix4fv(shader.uniforms.pMatrix, false, ctx.projectionMatrix);
        gl.uniformMatrix4fv(shader.uniforms.mvMatrix, false, ctx.modelViewMatrix);


        gl.drawArrays(vertexBuffer.glDrawMode, 0, vertexBuffer.itemCount);
    }
}
